import * as actionTypes from "./actionTypes";

export const getBundlesAll = () => ({
    type: actionTypes.GET_BUNDLES_ALL
});

export const getBundlesAllSucceeded = bundles => ({
    type: actionTypes.GET_BUNDLES_ALL_SUCCEEDED,
    bundles: bundles
});

export const getBundlesAllFail = () => ({
    type: actionTypes.GET_BUNDLES_ALL_FAIL,
});

export const getBundlePaymentOptions = bundleId => ({
    type: actionTypes.GET_BUNDLE_PAYMENT_OPTIONS,
    bundleId: bundleId,
});

export const getBundlePaymentOptionSucceeded = paymentOptions => ({
    type: actionTypes.GET_BUNDLE_PAYMENT_OPTIONS_SUCCEEDED,
    paymentOptions: paymentOptions
});

export const buyBundle = (bundleId, paymentType, idealBankId, clientBundleID) => ({
    type: actionTypes.BUY_BUNDLE,
    bundleId,
    paymentType,
    idealBankId,
    clientBundleID
});
export const buyBundleSucceeded = (url, id) => ({
    type: actionTypes.BUY_BUNDLE_SUCCEEDED,
    url,
    id
});

export const confirmBundlePayment = ({ paymentType,onlinePayment, history, url }) => ({
    type: actionTypes.CONFIRM_BUNDLE_PAYMENT,
    payload: {
        paymentType,
        onlinePayment,
        history,
        url,
    }
});
export const confirmBundlePaymentSucceeded = ({ paymentType, onlinePayment }) => ({
    type: actionTypes.CONFIRM_BUNDLE_PAYMENT_SUCCEEDED,
    payload: {
        paymentType,
        onlinePayment
    }
});

export const cancelBundlePayment = id => ({
    type: actionTypes.CANCEL_BUNDLE_PAYMENT,
    id
});

export const checkBundlePaymentStatus = id => ({
    type: actionTypes.CHECK_BUNDLE_PAYMENT_STATUS,
    id
});

export const updateBundlePaymentStatus = status => ({
    type: actionTypes.UPDATE_BUNDLE_PAYMENT_STATUS,
    status
});

export const selectBundle = bundleID => ({
    type: actionTypes.SELECT_BUNDLE,
    bundleID
});
